export default "__VITE_ASSET__df88bd03__"